import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { GlobalContext } from '@thd-olt-global/global-provider-component';
import BrowseSearchComponent from '@thd-olt-pages/browse-search';
import LayoutManager from '@thd-olt-component/layout-manager';
import { withHeaders } from '@thd-olt-global/thd-axios/withHeaders';
import { environmentKey } from '../../constants/key-provider';
import withPageChange from '../../components/PageChange';
import Helpers from '../../helpers/Helpers';

class BrowseSearchPage extends Component {
  static contextType = GlobalContext;

  shouldRenderEtch = (response = {}) => {
    const templates = response.templates || [];
    const partialTemplates = response.partialTemplates || [];
    const { options = {}, nexGen = false } = templates[0] || {};
    const { content_type: templatesContentType } = options;
    const hasPLPBanner = partialTemplates.length > 0
      && !!(Object.keys(partialTemplates[0]).find(k => k === 'PLP_Banner'));

    return (nexGen
      || templatesContentType === 'categorypage'
      || (templatesContentType === 'plppage' && hasPLPBanner)
    );
  }

  render() {
    const {
      cookies = {},
      expConfiguration = {},
      localizationStatus,
      localStore,
      request = {},
      visualNavPromos
    } = this.context;

    const { recsAndSearchDynamicAPIEnabled = 'false' } = expConfiguration;
    const recsAndSearchDynamicAPIEnabledBool = (recsAndSearchDynamicAPIEnabled === 'true');

    const { channel, env, segment } = request;
    const apiKey = environmentKey(env);

    // support opening PLPs in new tabs
    const linkType = ['b', 's'].indexOf(this.props.pageType) > -1 && channel === 'mobile'
      ? '_spa'
      : this.props.linkType;

    let { pathname, pageType, nttParam } = this.props;
    const { path } = request;
    if (typeof window === 'undefined') {
      pathname = path;
    }

    // This change is for T&T
    let ABFeatSmartfacets = false;
    if (typeof window !== 'undefined' && Helpers.isSearchPage({ pageType, nttParam })) {
      const getFacet = Helpers.getCookie('search_test');
      ABFeatSmartfacets = getFacet === 'smartfacet:1';
    }

    return (
      <LayoutManager input={{ page: 'browse-search' }} name="Collage Browse/Search Page">
        <LayoutManager.Group name="Browse Page">
          <BrowseSearchComponent
            {...this.props}
            ABFeatSmartfacets={ABFeatSmartfacets}
            apiKey={apiKey}
            channel={channel}
            env={env}
            linkType={linkType}
            localStore={localStore}
            localizationStatus={localizationStatus}
            pathname={pathname}
            recsAndSearchDynamicAPIEnabled={recsAndSearchDynamicAPIEnabledBool}
            segment={segment}
            topFiltersOffset={63}
            topFiltersSticky
            visualNavPromos={visualNavPromos}
            shouldRenderEtch={this.shouldRenderEtch}
          />
        </LayoutManager.Group>
      </LayoutManager>
    );
  }
}

BrowseSearchPage.propTypes = {
  linkType: PropTypes.string.isRequired,
  nttParam: PropTypes.string.isRequired,
  nValue: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
  pageType: PropTypes.string.isRequired,
  pathname: PropTypes.string.isRequired,
  push: PropTypes.func.isRequired,
  querystring: PropTypes.string,
  replace: PropTypes.func.isRequired,
  sValue: PropTypes.string.isRequired
};

BrowseSearchPage.defaultProps = {
  querystring: null
};

const headers = [{
  name: 'x-thd-canaveral-assignment',
  contextKey: 'canaveralAssignment',
  test: /SearchNav\/v2\/pages\/search/,
  onResponse: (resp, header) => {
    if (typeof window !== 'undefined') {
      Helpers.setCookie(header.name, header.value, 30);
    }
  }
}, {
  name: 'llc-env',
  contextKey: 'llcEnv',
  test: /SearchNav\/v2\/pages\/search|productModel/,
  transformer: (value) => {
    if (/q2/.test(value)) {
      return 'q2';
    }
    return value;
  }
}, {
  name: 'tt_search',
  contextKey: 'ttSearch',
  test: /SearchNav\/v2\/pages\/search/
}];

export default withPageChange(
  withHeaders(headers)(BrowseSearchPage)
);
